/**
 * @file: useOrderDetailPropsFromServiceRecord.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { OrderDetailContextProps } from '@euler/app/flows/order/types';
import { VehicleServiceRecord } from '@euler/model';
import { useMemo } from 'react';

export const useOrderDetailPropsFromServiceRecord = (
  serviceRecord: VehicleServiceRecord,
) => {
  return useMemo<OrderDetailContextProps>(() => {
    const {
      orderNo,
      licensePlateNo,
      vin,
      tags,
      mileage: vehicleMileage,
      vehicleName,
      vehicleBrand: vehicleBrandName,
      serviceAgentName,
      carwashType,
      reservationType,
      returnType,
      oldPartDisposalType,
      insuranceExpiryDate,
      customerType,
      customerName,
      customerMobile,
      remark,
      dashboardImgUrl,
      signImgUrl,
      orderDetail,
    } = serviceRecord;
    return {
      orderNo,
      licensePlateNo,
      vin,
      tags,
      vehicleMileage,
      vehicleName,
      vehicleBrandName,
      serviceAgentName,
      carwashType,
      reservationType,
      returnType,
      oldPartDisposalType,
      estimatedFinishTime: undefined,
      insuranceExpiryDate,
      customerType,
      customerName,
      customerMobile,
      dashboardImageUrl: dashboardImgUrl,
      signImgUrl,
      remark,
      orderDetail,
      getQrcodeImageUrl: undefined,
      preInspection: undefined,
    };
  }, [serviceRecord]);
};
